import { formatDateToLocale, Formats } from '@toggle/helpers';
import { DetailedInsight, InsightsEpisode, TSDatum } from '@toggle/toggle';
import { format as tzFormat, toZonedTime } from 'date-fns-tz';
import { TFunction } from 'i18next';

import { useLanguageStore } from '~/stores/use-language-store/useLanguageStore';
import { InsightWidgetData } from '~/views/alfred/quick-analysis/use-chat/assistant-response.type';

export const getInsightTotalTradingDays = (insight: DetailedInsight) => {
  return insight.episodes.reduce((acc, ep) => acc + ep.events.length, 0);
};

export const getInsightEpisodeDates = (episodes: InsightsEpisode[]) => {
  const languageSetting = useLanguageStore.getState().languageSetting;
  return episodes.map(episode =>
    formatDateToLocale(
      languageSetting,
      new Date(episode.start_date),
      Formats['yyyy-MM-dd']
    )
  );
};

export const filterPredictions = (
  data: InsightWidgetData,
  indexMax: number
) => {
  return {
    ...data,
    predictions: data.predictions.filter((_, i) => i <= indexMax),
    scores: {},
    confidence: 1,
  };
};

export const getInsightCondition = (insight: DetailedInsight, t: TFunction) => {
  const conditionStrings = insight.conditions
    .map(condition => condition.condition_text.trim())
    .filter(Boolean);

  if (!conditionStrings.length) {
    return '';
  }

  const andLabel = t('scenarioCommander:domino.and');
  return conditionStrings.join(`${andLabel}\n`);
};

export const formatCumulativeReturnSnake = (
  data: TSDatum[],
  startDate: string
) => {
  const foundIndex = data.findIndex(
    d => d.index.slice(0, 10) === startDate.slice(0, 10)
  );
  const startIndex = foundIndex === -1 ? 0 : foundIndex;
  return data.slice(startIndex).map((d, idx) => ({
    index: idx,
    value: d.value,
  }));
};

export const formatUtcDate = (dateString: string, pattern: string) => {
  const languageSetting = useLanguageStore.getState().languageSetting;
  const isValidPattern = Object.hasOwn(Formats, pattern);
  const utcDate = toZonedTime(new Date(dateString), 'UTC');
  return isValidPattern
    ? formatDateToLocale(
        languageSetting,
        utcDate,
        Formats[pattern as keyof typeof Formats]
      )
    : tzFormat(utcDate, pattern);
};
